import React from 'react'
import { ListItem, ListItemText, ListItemIcon, Skeleton } from '@mui/material'

const BillingAddressSkeleton = () => (
  <ListItem>
    <ListItemText
      primary={<Skeleton width={180} height={24} />}
      secondary={<Skeleton width="60%" height={20} />}
    />
    <ListItemIcon>
      <Skeleton variant="circular" width={24} height={24} />
    </ListItemIcon>
  </ListItem>
)

export default BillingAddressSkeleton
